/* eslint-disable no-nested-ternary */
/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
// import _ from 'lodash';
import pdfUtil from '../../../../../utils/PDFUtil';
import Image from '../../../../../components/ZUILib/Image';
import Intransit from './Intransit';
import StatementPrintAndDownload from '../StatementPrintAndDownload';
import Link from '../../../../../components/ZUILib/Link';
import InputButton from '../../../../../components/ZUILib/InputButton';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import commonUtil from '../../../../../utils/commonUtil';
import ValeSystemModal from './valeSystemModal';
import TemporaryClosingModal from './temporaryClosingModal';
import {
  constDownload,
  constSendMail,
  eventStatus,
  eventCategory,
} from '../../../../../utils/clientConstant';
import AppEvents from '../../../../App/AppEvents';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import {
  sendMail,
  // initiateEventCloseProcess,
  // getTransferenceOptions,
} from '../../actions';
import Tagging from '../../../../../components/Tagging/Tagging';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

const pageName = 'accountstatus';
export default class AccountStatusWAP extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.eventId;
    this.eventOwnerId = this.props.eventInfo.ownerId;
    this.currentTime = '';
    this._StartTime = '';
    this._EndTime = '';
    this.AllowedStartTime = '';
    this.AllowedEndTime = '';
    this.type = 'closure';
    this.isValeSystemDown = false;
    this.state = {
      emailSendStatus: null,
      accountStatementError: null,
    };
  }
  UNSAFE_componentWillMount() {
    const accountStatus = this.props.accountStatus;
    this.currentTime = accountStatus.currTime;
    this._StartTime = commonUtil.formatDate(
      accountStatus.eventAccountStatementInfo.transferenceAllowedStartTime,
      'hour12',
    );
    this._EndTime = commonUtil.formatDate(
      accountStatus.eventAccountStatementInfo.transferenceAllowedEndTime,
      'hour12',
    );
    // this.isValeSystemDown = !accountStatus.accountSystemAvailable;
  }
  componentDidMount() {
    if (channel === constChannels.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(
        AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED,
      );
      if (this.wapBackButtonEvent) {
        AppEvents.publish(this.wapBackButtonEvent, [
          () => {
            browserHistory.push(
              commonUtil.routeTo(applicationRoutes.giftList, {
                eventID: this.props.eventId,
              }),
            );
          },
        ]);
      }
    }
  }
  componentWillUnMount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }
  onCerrarMesaButtonClick = () => {
    this.temporaryClosingModal.handleShow();
  };
  onTemporaryClosingModalAcceptor = () => {
    this.temporaryClosingModal.handleHide();
    // redirect to closure
    browserHistory.push({
      pathname: commonUtil.getRouteByParameter(
        applicationRoutes.closureTransference,
        { eventID: this.eventId },
      ),
      state: {
        eventOwnerId: this.eventOwnerId,
        openEvent:
          this.props.eventInfo.eventCategory === eventCategory.OPENEVENT,
      },
    });
  };

  onPartialTransferenceButtonClick = () => {
    // redirect to Retiros Anticipados
    browserHistory.push({
      pathname: commonUtil.getRouteByParameter(
        applicationRoutes.partialTransference,
        { eventID: this.eventId },
      ),
      state: { eventOwnerId: this.eventOwnerId },
    });
  };

  getStatementDetailsForDownload = () => {
    this.printDownloadMail(constDownload);
  };
  getStatementDetailsForSendMail = () => {
    this.printDownloadMail(constSendMail);
  };
  accountStatementSendMail = (fileName, data) => {
    const emailId =
      !commonUtil.isObjectEmpty(this.props.user) &&
      this.props.user.result &&
      this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status === 'success') {
        this.setState({
          emailSendStatus: {
            isSent: true,
            resMsg: commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.emailsent.message',
            ),
          },
        });
      } else {
        this.setState({
          emailSendStatus: {
            isSent: false,
            resMsg: commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.emailfailed.message',
            ),
          },
        });
      }
    });
  };

  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }
  printDownloadMail = (type) => {
    if (type === constSendMail) {
      const mailContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
          download
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDomForMail(
        mailContent,
        'accountStatement',
        this.accountStatementSendMail,
      );
    } else if (type === constDownload) {
      const downloadableContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
          download
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDom(downloadableContent, 'accountstatus_' + this.eventId);
    }
  };
  openTransitModal = () => {
    this.transitModal.handleShow();
  };

  render() {
    const status = this.props.accountStatus;
    const eventInfo = this.props.eventInfo;
    const accountData = status.eventAccountStatementInfo;

    const eventProfileImageLink = {
      id: 'link',
      alt: 'Liverpool',
      src: eventInfo.eventProfileImage,
      altImg: commonUtil.getAssetURL() + '/images/avatar.svg',
    };

    const DownloadIcon = {
      route: '',
    };
    const cerrarMesaButton = {
      type: 'button',
      value: 'Cerrar Mesa',
      id: 'CerrarMesa',
      autoFocus: false,
      disabled:
        accountData.enableEventClosure.toString() === 'true' ? '' : 'disabled',
      cssStyle: {
        borderRadius: '4px',
      },
      style:
        accountData.enableEventClosure.toString() === 'true'
          ? 'btnPrimary size-Full'
          : 'btnPrimary primaryDisabled size-Full',
      onClickHandler: this.onCerrarMesaButtonClick,
    };

    const infoGiftsPhysicalJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.physicalGifts, {
        eventID: this.eventId,
      }),
    };

    const infoGiftsPersonalJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(
        applicationRoutes.personalPurchases,
        { eventID: this.eventId },
      ),
    };

    const infoGiftsElectronicJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.electronicsGift, {
        eventID: this.eventId,
      }),
    };

    const infoPartialTransferencesJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(
        applicationRoutes.accountsPartialTransfer,
        { eventID: this.eventId },
      ),
    };

    const bonusDetail = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.bonusDetails, {
        eventID: this.eventId,
      }),
    };

    const linkDatosDeEvento = {
      displayName: 'Ver detalle',
      // route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'DatosDeMiEvento', eventID: this.eventId }),
      route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, {
        pageName: 'EventManagementIndex',
        eventID: this.eventId,
      }),
    };

    const partialTransferenceButton = {
      id: 'partialTransferance',
      type: 'button',
      value: 'Retiro anticipado',
      disabled:
        accountData.enablePartialTransfer.toString() === 'true'
          ? ''
          : 'disabled',
      autoFocus: false,
      style:
        accountData.enablePartialTransfer.toString() === 'true'
          ? 'btnPrimarySpecial size-Full'
          : 'btnPrimarySpecial specialDisabled size-Full',
      cssStyle: {
        borderRadius: '4px',
      },
      onClickHandler: this.onPartialTransferenceButtonClick,
    };
    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => {
        this.setState({ emailSendStatus: null });
      },
    };
    const accountStatementErrorLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => {
        this.setState({ accountStatementError: null });
      },
    };

    const itemInfo = status.eventAccountStatementInfo.itemsInfo;
    const amountInfo = status.eventAccountStatementInfo.amountInfo;
    const isBonusContainerVisible = commonUtil.isBonusAvailable(
      this.props.eventInfo,
    );

    const inTransitHeaderData = (
      <p>
        {commonUtil.getLabel(
          this.props.lables['In transit – Pop up'],
          'accountStatement.intransit.message',
        )}
      </p>
    );

    const closeSpan = {
      backgroundColor: 'transparent',
      color: '#666666',
      display: 'flex',
      fontSize: '2em',
      fontWeight: '100',
    };

    const modalTitle = {
      color: '#000000',
      fontWeight: 600,
      fontSize: '18px',
    };

    const wapFlexIcons = {
      display: 'flex',
      alignItems: 'center',
    };

    return (
      <React.Fragment>
        <Tagging ref={tagging => (this.tagging = tagging)} />
        <div className="row adminInfo">
          <div className="col-xs-3">
            <Image imageAttr={eventProfileImageLink} />
          </div>
          <div className="col-xs-7">
            <h2>{eventInfo.eventName}</h2>
            <span className="eventDate">
              {commonUtil.getLabel(
                this.props.lables.eventAccountStatement,
                'accountStatement.eventDate.Label',
              )}
              : {eventInfo.eventDate}
            </span>
            <span className="eventDate">
              {commonUtil.getLabel(
                this.props.lables.eventAccountStatement,
                'accountStatement.eventId.Label',
              )}
              : {eventInfo.eventId}
            </span>
          </div>
          <div className="col-xs-2">
            <Link rrLink={linkDatosDeEvento}>
              <i className="icon-flecha_gruesa_derecha" />
            </Link>
          </div>
        </div>
        <div className="accountState">
          {this.state.emailSendStatus ? (
            <React.Fragment>
              {this.state.emailSendStatus.isSent ? (
                <div className="alertSuccess">
                  {' '}
                  <i className="icon-check" />
                  <p>{this.state.emailSendStatus.resMsg}</p>
                  <Link linkJSON={emailSendLink} />
                </div>
              ) : (
                <div className="alertError">
                  {' '}
                  <i className="icon-tache2" />
                  <p>{this.state.emailSendStatus.resMsg}</p>
                  <Link linkJSON={emailSendLink} />
                </div>
              )}
            </React.Fragment>
          ) : null}
          {this.state.accountStatementError ? (
            <div className="alertError">
              {' '}
              <i className="icon-tache2" />
              <p>{this.state.accountStatementError}</p>
              <Link linkJSON={accountStatementErrorLink} />
            </div>
          ) : null}
          <div className="row">
            <div className="col-xs-12">
              <div className="col-xs-8 pt-15 pl-0">
                <p className="name">Estado de cuenta</p>
              </div>
              <div className="col-xs-4 pt-15 pr-0">
                <div className="toolsLink text-right" style={wapFlexIcons}>
                  <Link rrLink={DownloadIcon}>
                    <i
                      className="icon-descarga"
                      onClick={this.getStatementDetailsForDownload}
                      aria-hidden="true"
                    />
                  </Link>
                  <Link rrLink={DownloadIcon}>
                    <i
                      className="icon-correo"
                      onClick={this.getStatementDetailsForSendMail}
                      aria-hidden="true"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="row pr-15 pl-15">
            <div className="col-xs-12 legend bb-1 bt-1 bc-gray">
              {commonUtil.getLabel(
                this.props.lables.eventAccountStatement,
                'accountStatement.statement.message',
              )}
            </div>
          </div>
          <div className="row pt-15 pb-15">
            <div className="col-xs-12">
              {eventInfo.eventStatus === eventStatus.CLOSED ? (
                <p>
                  <strong>
                    {commonUtil.getLabel(
                      this.props.lables['event closure success page'],
                      'eventClosure.success.message',
                    )}
                  </strong>
                  <br />
                  {commonUtil.getLabel(
                    this.props.lables['event statement page'],
                    'eventClosure.closed.message',
                  )}
                </p>
              ) : (
                <InputButton buttonAttr={cerrarMesaButton} />
              )}
              {accountData.employeeClosureMessage ? (
                accountData.eventMessage.indexOf('No cuentas') === -1 ? (
                  <p style={{ paddingTop: '5%' }}>
                    No cuentas con tu tarjeta Liverpool registrada, para cerrar
                    tu mesa de regalos visita tienda.
                  </p>
                ) : (
                  <p>{accountData.employeeClosureMessage}</p>
                )
              ) : (
                <React.Fragment>
                  {accountData.eventMessage &&
                  accountData.eventMessage.indexOf('Muchas') > -1 ? (
                    ''
                  ) : (
                    <div>
                      {commonUtil.getLabel(
                        this.props.lables.eventAccountStatement,
                        'accountStatement.closure.message',
                      )}
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
          <div className="row mt-5 pr-15 pl-15">
            <div className="col-xs-12 shadowSquare summaryAccountMobilInfo">
              <div className="row titulo1 bb-1 bbc-black innerItem">
                <div className="col-xs-12">
                  <div className="col-xs-7">
                    <p className="titleTotalGift">
                      {commonUtil.getLabel(
                        this.props.lables.eventAccountStatement,
                        'accountStatement.totalPurchase.message',
                      )}
                      <span className="labelPink">
                        ({itemInfo.totalPurchasedItemsCount})
                      </span>
                    </p>
                  </div>
                  <div className="col-xs-5">
                    <p className="priceTotal" style={{ fontWeight: '700' }}>
                      {commonUtil.getCurrency(amountInfo.totalPurchasedAmount)}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row bb-1 bbc-gray innerItem">
                <div className="col-xs-12">
                  <div className="td-40">
                    {'Regalos físicos'} (
                    {itemInfo.physicalItemInfo.totalPurchasedItems})
                  </div>
                  <div className="td-40 text-right">
                    {commonUtil.getCurrency(
                      itemInfo.physicalItemInfo.totalPurchasedAmount,
                    )}
                  </div>
                  <div className="td-16 text-right">
                    <Link rrLink={infoGiftsPhysicalJson}>
                      <i className="icon-flecha_gruesa_derecha" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row bb-1 bbc-gray innerItem">
                <div className="col-xs-12">
                  <div className="td-40">
                    Compras personales (
                    {itemInfo.personalItemInfo.totalPurchasedItems})
                  </div>
                  <div className="td-40 text-right">
                    {commonUtil.getCurrency(
                      itemInfo.personalItemInfo.totalPurchasedAmount,
                    )}
                  </div>
                  <div className="td-16 text-right">
                    <Link rrLink={infoGiftsPersonalJson}>
                      <i className="icon-flecha_gruesa_derecha" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row innerItem">
                <div className="col-xs-12">
                  <div className="td-40">
                    Regalos electronicos (
                    {itemInfo.electronicItemInfo.totalPurchasedItems})
                  </div>
                  <div className="td-40 text-right">
                    {commonUtil.getCurrency(
                      itemInfo.electronicItemInfo.totalPurchasedAmount,
                    )}
                  </div>
                  <div className="td-16 text-right">
                    <Link rrLink={infoGiftsElectronicJson}>
                      <i className="icon-flecha_gruesa_derecha" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pr-15 pl-15">
            {itemInfo.electronicItemInfo.amountTransferred ? (
              <div className="col-xs-12 shadowSquare mt-5 summaryAccountMobilInfo">
                <div className="innerItem">
                  <div className="td-40">Retiros anticipados</div>
                  <div className="td-40 text-right">
                    -
                    {commonUtil.getCurrency(
                      itemInfo.electronicItemInfo.amountTransferred,
                    )}
                  </div>
                  <div className="td-16 text-right">
                    <Link rrLink={infoPartialTransferencesJson}>
                      <i className="icon-flecha_gruesa_derecha" />
                    </Link>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="row pr-15 pl-15">
            <div className="col-xs-12 shadowSquare mt-5 drawOn">
              <div>
                <div className="col-xs-12 info">
                  <p className="disponibility">Disponible para retiro</p>
                  <p className="mont" style={{ fontWeight: '700' }}>
                    {commonUtil.getCurrency(amountInfo.transferableAmount)}
                  </p>
                  <p className="legeng">{accountData.transferenceMessage}</p>
                </div>
                <div className="col-xs-12">
                  <div
                    className="innerItem"
                    data-toggle="modal"
                    data-target="#modalTransit"
                  >
                    {+amountInfo.inTransitAmount !== 0 ? (
                      <div>
                        <div onClick={this.openTransitModal}>
                          <div className="td-40">En tránsito</div>
                          <div className="td-40 text-right">
                            {commonUtil.getCurrency(amountInfo.inTransitAmount)}
                          </div>
                          <div className="td-16 text-right">
                            <i className="icon-flecha_gruesa_derecha" />
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <ModalPopover
                      ref={transitModal => (this.transitModal = transitModal)}
                      isModal="true"
                      header="Regalos en tránsito"
                      headerData={inTransitHeaderData}
                      modalId="transitProducts"
                    >
                      <Intransit
                        inTransitInfoData={this.props.intransitData}
                        lables={this.props.lables}
                      />
                    </ModalPopover>
                  </div>
                </div>
                {eventInfo.eventStatus === eventStatus.CLOSED ? (
                  ''
                ) : (
                  <div className="col-xs-12 pt-15">
                    <InputButton buttonAttr={partialTransferenceButton} />
                    {accountData.employeeClosureMessage ? (
                      accountData.eventMessage.indexOf('No cuentas') === -1 ? (
                        <p style={{ paddingTop: '5%' }}>
                          Para hacer un retiro anticipado registra tu tarjeta en
                          tienda.
                        </p>
                      ) : (
                        <p>{accountData.employeeClosureMessage}</p>
                      )
                    ) : (
                      <React.Fragment>
                        {accountData.eventMessage &&
                        accountData.eventMessage.indexOf('Muchas') > -1 ? (
                          ''
                        ) : (
                          <div>
                            {commonUtil.getLabel(
                              this.props.lables.eventAccountStatement,
                              'accountStatement.closure.message',
                            )}
                          </div>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {isBonusContainerVisible ? (
            <div className="row pr-15 pl-15">
              <div className="col-xs-12 shadowSquare mt-5 summaryAccountMobilInfo drawOn">
                <div className="innerItem pr-15 pl-15">
                  <div className="td-80">
                    <p className="approximate">Aproximado de bono a monedero</p>
                    <p className="mont" style={{ fontWeight: '700' }}>
                      {commonUtil.getCurrency(amountInfo.totalBonusAmount)}
                    </p>
                    {eventInfo.isEmployeeEvent ? (
                      <p className="ofert">
                        {' '}
                        Por ser evento de casa {
                          accountData.bonusPercentage
                        }%{' '}
                        {commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.bonus.message',
                        )}
                        , máximo a recibir{' '}
                        {commonUtil.getCurrency(amountInfo.totalBonusAmount)}
                      </p>
                    ) : (
                      <p className="ofert">
                        {accountData.bonusPercentage}%{' '}
                        {commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.bonus.message',
                        )}{' '}
                      </p>
                    )}
                  </div>
                  <div className="td-16 text-right">
                    <Link rrLink={bonusDetail}>
                      <i className="icon-flecha_gruesa_derecha" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <ModalPopover
          ref={system => (this.valeSystemModal = system)}
          isModal="true"
        >
          <button
            className="close closeClass"
            id="closeModal"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span className="closeModal" aria-hidden="true" style={closeSpan}>
              ×
            </span>
          </button>
          <h4>
            <strong>
              {commonUtil.getLabel(
                this.props.lables[
                  'Event Account Landing page – Vales system down'
                ],
                'accountStatement.valesystemdown.message1',
              )}
            </strong>
          </h4>
          <ValeSystemModal
            lables={this.props.lables}
            startTime={this._StartTime}
            endTime={this._EndTime}
          />
        </ModalPopover>
        <ModalPopover
          modalId="modalWAP"
          ref={system => (this.temporaryClosingModal = system)}
          isModal="true"
        >
          <button
            className="close closeClass"
            id="closeModal"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span className="closeModal" aria-hidden="true" style={closeSpan}>
              ×
            </span>
          </button>
          <h4 style={modalTitle}>Cerrar mesa de regalos</h4>
          <TemporaryClosingModal
            lables={this.props.lables}
            temporaryModal={this.onTemporaryClosingModalAcceptor}
            eventId={this.eventId}
          />
        </ModalPopover>
      </React.Fragment>
    );
  }
}
